export default __webpack_public_path__ + "static/media/circle-thumbnail-backdrop-1x.3da18328.png";